// /src/core/toastr.js

import { Alpine } from './alpine-core.js'

/** `crypto.randomUUID` is missing on non-secure origins (http LAN) in some browsers. */
function newToastrMessageId() {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  return `m-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

Alpine.store('toastr', {
  messages: [],
  add(type, text, timeout = 3000, extras = {}) {
    const id = newToastrMessageId();
    const actionLabel = String(extras?.actionLabel || '').trim();
    const actionHref = String(extras?.actionHref || '').trim();
    this.messages.push({
      id,
      type,
      text,
      actionLabel: actionLabel || null,
      actionHref: actionHref || null,
    });
    if (timeout > 0) {
      setTimeout(() => this.remove(id), timeout);
    }
  },
  remove(id) {
    this.messages = this.messages.filter(m => m.id !== id)
  },
  runAction(message) {
    const href = String(message?.actionHref || '').trim();
    if (!href) return;
    this.remove(message.id);
    const R = globalThis.PineconeRouter;
    if (R?.navigate) R.navigate(href);
    else globalThis.location.assign(href);
  },

  success(text, timeout, extras) { this.add('success', text, timeout, extras) },
  info(text, timeout, extras) { this.add('info', text, timeout, extras) },
  warning(text, timeout, extras) { this.add('warning', text, timeout, extras) },
  error(text, timeout, extras) { this.add('error', text, timeout, extras) },
})
